module.exports = __webpack_public_path__ + "static/ardex-global-00-hero-2f49bcf8dc3e83906bb59719f2dbabac.jpg";